import { useSelector } from 'react-redux';

import { useApiQuery } from 'theSource/utils';
import { selectIsAuthenticated } from 'theSource/features';
import { GET_BENEFICARY_QUERY_KEY } from './utils';
import { useConfigurationQuery } from 'theSource/queries';
import { BeneficiaryMetadataResponseDto } from './types';

export interface UseEnrollmentBeneficiaryQueryProps {
  selectionOptions?: any;
}

export const useEnrollmentBeneficiaryQuery = ({
  selectionOptions = null,
}: UseEnrollmentBeneficiaryQueryProps) => {
  const { configuration } = useConfigurationQuery();
  const apiHost = configuration?.apiHost;

  const isAuthenticated = useSelector(selectIsAuthenticated);

  const { data, isLoading } = useApiQuery<BeneficiaryMetadataResponseDto>({
    queryKey: GET_BENEFICARY_QUERY_KEY,
    config: {
      baseURL: `${apiHost}/v2/self_service`,
    },
    endpoint: `/beneficiaries/metadata`,
    params: {
      selection_options: selectionOptions,
    },
    enabled: Boolean(isAuthenticated),
  });

  return { data, isLoading };
};
